export const UPDATE_ACCOUNT_DETAILS = 'UPDATE_ACCOUNT_DETAILS';
export const UPDATE_ACCOUNT_DETAILS_DONE = 'UPDATE_ACCOUNT_DETAILS_DONE';
export const UPDATE_ACCOUNT_DETAILS_ERROR = 'UPDATE_ACCOUNT_DETAILS_ERROR';
export const UPDATE_ACCOUNT_DETAILS_RESET = 'UPDATE_ACCOUNT_DETAILS_RESET';
//# sourceMappingURL=actionTypes.js.map